export enum Direction {
    NONE,
    NEXT,
    PREV
}
